import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions as authActions } from '@saucelabs/sl-container-authentication';
import { IconCheckmarkFill } from '@saucelabs/ds-icons';
import { constants } from '@saucelabs/sl-util-segmentio';

import { trackEvent } from './../../../tracking';
import Banner from '../Banner';

const { EVENT_CATEGORY } = constants;

const UnverifiedAlert = ({ email, resendEmail }) => {
  const [sendEmailTimeout, setSendEmailTimeout] = useState(undefined);

  const EmailSendBtn = () => (
    <span className="text-green-600 text-blue-700 font-semibold p-1">
      <IconCheckmarkFill
        className="fill-current mr-1 align-middle"
        height="16"
        width="16"
      />
      <span>Email sent!</span>
    </span>
  );

  const ResendEmailBtn = () => (
    <span
      className="font-bold cursor-pointer text-blue-700 font-semibold p-1"
      data-qa="resend-email-verification"
      onClick={() => {
        if (sendEmailTimeout) clearTimeout(sendEmailTimeout);
        const timeout = setTimeout(() => setSendEmailTimeout(undefined), 6000);
        setSendEmailTimeout(timeout);

        resendEmail();
        trackEvent(EVENT_CATEGORY.OBJECT_CLICKED, {
          product_area: 'Growth',
          product_sub_area: 'Email Verification Banner',
          subject_name: 'Resend Email Verification',
          domain: window.location.origin,
          page: 'Email Verification Banner',
        });
      }}
      role="button"
      tabIndex={-1}
    >
      Resend
    </span>
  );

  const WarningAlertText = () => (
    <span>
      <span>{`We have sent a verification email with instructions to ${email}.` }</span>
      {sendEmailTimeout ? <EmailSendBtn /> : <ResendEmailBtn />}
    </span>
  );

  return (
    <Banner
      color="orange"
    >
      <div className="flex flex-row justify-center items-center">
        <p className="my-0 mx-1 text-base">
          <strong>Verify your email:</strong>
          {' '}
          <WarningAlertText />
        </p>
      </div>
    </Banner>
  );
};

UnverifiedAlert.propTypes = {
  email: PropTypes.string.isRequired,
  resendEmail: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  resendEmail: () => dispatch(authActions.resendEmail()),
});

export default connect(null, mapDispatchToProps)(UnverifiedAlert);
export { UnverifiedAlert };
